(() => {
  const CLIENT_ID = '034a661a-bd75-438f-a3c0-bf5a36e03e63';
  const SHOP_ID = '78192115944';
  const ISSUER = `https://shopify.com/authentication/${SHOP_ID}`;
  const PENDING_KEY = `simpson-hub-auth-${CLIENT_ID}`;
  const LOGOUT_KEY = `simpson-hub-logout-${CLIENT_ID}`;
  const SESSION_KEY = `simpson-hub-session-${CLIENT_ID}`;
  const ATTEMPT_KEY = `simpson-hub-attempt-${CLIENT_ID}`;
  const SIGNIN_KEY = `simpson-hub-signin-${CLIENT_ID}`;
  const SESSION_LIMIT = 8 * 60 * 60 * 1000;
  const ADDRESS_FIELDS = 'id firstName lastName company address1 address2 city zoneCode countryCode: territoryCode zip phoneNumber formatted(withName: true)';
  const OPERATIONS = {
    shipmentEvents: "query HubShipmentEvents($orderQuery: String!, $shipmentQuery: String!, $after: String, $itemsAfter: String) { customer { id orders(first: 1, query: $orderQuery) { nodes { id fulfillments(first: 1, query: $shipmentQuery) { nodes { id events(first: 50, after: $after) { nodes { id status happenedAt } pageInfo { hasNextPage endCursor } } fulfillmentLineItems(first: 50, after: $itemsAfter) { nodes { id quantity lineItem { id title variantTitle quantity price { amount currencyCode } totalPrice { amount currencyCode } image { url } } } pageInfo { hasNextPage endCursor } } } } } } } }",
    orders: "query HubOrders($after: String) { customer { id orders(first: 20, after: $after, reverse: true, sortKey: PROCESSED_AT) { nodes { id name createdAt processedAt financialStatus fulfillmentStatus cancelledAt requiresShipping totalPrice { amount currencyCode } totalRefunded { amount currencyCode } shippingLine { title } lineItems(first: 3) { nodes { title quantity image { url } } pageInfo { hasNextPage endCursor } } fulfillments(first: 50) { nodes { id status latestShipmentStatus requiresShipping isPickedUp estimatedDeliveryAt trackingInformation { company number url } } pageInfo { hasNextPage endCursor } } } pageInfo { hasNextPage endCursor } } } }",
    orderDetail: "query HubOrderDetail($query: String!, $itemsAfter: String, $shipmentsAfter: String) { customer { id orders(first: 1, query: $query) { nodes { id name createdAt processedAt financialStatus fulfillmentStatus cancelledAt requiresShipping totalPrice { amount currencyCode } totalRefunded { amount currencyCode } shippingLine { title } statusPageUrl subtotal { amount currencyCode } totalShipping { amount currencyCode } totalTax { amount currencyCode } totalDuties { amount currencyCode } lineItems(first: 50, after: $itemsAfter) { nodes { id title variantTitle quantity totalPrice { amount currencyCode } image { url } } pageInfo { hasNextPage endCursor } } fulfillments(first: 50, after: $shipmentsAfter) { nodes { id status latestShipmentStatus requiresShipping isPickedUp estimatedDeliveryAt trackingInformation { company number url } } pageInfo { hasNextPage endCursor } } } } } }",
    profile: `query HubProfile($after: String) { customer { id firstName lastName emailAddress { emailAddress marketingState } phoneNumber { phoneNumber smsMarketingConsent { state } } defaultAddress { id } addresses(first: 50, after: $after) { nodes { ${ADDRESS_FIELDS} } pageInfo { hasNextPage endCursor } } } }`,
    name: 'mutation HubProfileUpdate($input: CustomerUpdateInput!) { customerUpdate(input: $input) { customer { id firstName lastName } userErrors { field message code } } }',
    emailSubscribe: 'mutation HubEmailSubscribe { customerEmailMarketingSubscribe { emailAddress { emailAddress marketingState } userErrors { field message } } }',
    emailUnsubscribe: 'mutation HubEmailUnsubscribe { customerEmailMarketingUnsubscribe { emailAddress { emailAddress marketingState } userErrors { field message } } }',
    create: 'mutation HubAddressCreate($address: CustomerAddressInput!, $defaultAddress: Boolean) { customerAddressCreate(address: $address, defaultAddress: $defaultAddress) { customerAddress { id } userErrors { field message code } } }',
    update: 'mutation HubAddressUpdate($addressId: ID!, $address: CustomerAddressInput, $defaultAddress: Boolean) { customerAddressUpdate(addressId: $addressId, address: $address, defaultAddress: $defaultAddress) { customerAddress { id } userErrors { field message code } } }',
    delete: 'mutation HubAddressDelete($addressId: ID!) { customerAddressDelete(addressId: $addressId) { deletedAddressId userErrors { field message code } } }'
  };
  // Use one initial customer read for the profile and the first page of orders.
  OPERATIONS.bootstrap = OPERATIONS.profile.replace('HubProfile', 'HubBootstrap').replace(/\} \}$/, OPERATIONS.orders.slice(OPERATIONS.orders.indexOf('orders(first:')));
  const REGIONS = {
    US: 'AL:Alabama|AK:Alaska|AZ:Arizona|AR:Arkansas|CA:California|CO:Colorado|CT:Connecticut|DE:Delaware|DC:District of Columbia|FL:Florida|GA:Georgia|HI:Hawaii|ID:Idaho|IL:Illinois|IN:Indiana|IA:Iowa|KS:Kansas|KY:Kentucky|LA:Louisiana|ME:Maine|MD:Maryland|MA:Massachusetts|MI:Michigan|MN:Minnesota|MS:Mississippi|MO:Missouri|MT:Montana|NE:Nebraska|NV:Nevada|NH:New Hampshire|NJ:New Jersey|NM:New Mexico|NY:New York|NC:North Carolina|ND:North Dakota|OH:Ohio|OK:Oklahoma|OR:Oregon|PA:Pennsylvania|RI:Rhode Island|SC:South Carolina|SD:South Dakota|TN:Tennessee|TX:Texas|UT:Utah|VT:Vermont|VA:Virginia|WA:Washington|WV:West Virginia|WI:Wisconsin|WY:Wyoming|AA:Armed Forces Americas|AE:Armed Forces Europe|AP:Armed Forces Pacific',
    CA: 'AB:Alberta|BC:British Columbia|MB:Manitoba|NB:New Brunswick|NL:Newfoundland and Labrador|NT:Northwest Territories|NS:Nova Scotia|NU:Nunavut|ON:Ontario|PE:Prince Edward Island|QC:Quebec|SK:Saskatchewan|YT:Yukon'
  };
  const COUNTRIES = 'AC AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TA TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'.split(' ');
  const enc = new TextEncoder();
  const base64url = bytes => btoa(String.fromCharCode(...bytes)).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/, '');
  const random = () => base64url(crypto.getRandomValues(new Uint8Array(32)));
  class AccountError extends Error {
    constructor(key, messages = []) { super(key); this.key = key; this.messages = messages; }
  }
  class SimpsonHubAccount {
    constructor(hub) {
      this.hub = hub;
      // Opt-in timing data contains only fixed stage names and durations.
      this.timings = [];
      try {
        const debug = new URL(location.href).searchParams.get('hub_debug');
        if (debug === '1') sessionStorage.setItem('simpson-hub-timing-enabled', '1');
        if (debug === '0') sessionStorage.removeItem('simpson-hub-timing-enabled');
        this.diagnostics = sessionStorage.getItem('simpson-hub-timing-enabled') === '1';
      } catch { this.diagnostics = false; }
      this.copy = JSON.parse(hub.querySelector('[data-hub-account-copy]')?.textContent || '{}');
      this.customerId = hub.dataset.customerId;
      this.auth = null;
      this.profile = null;
      this.busy = false;
      this.uncertain = false;
      this.dead = false;
      const signal = hub.listeners.signal;
      hub.addEventListener('click', event => this.click(event), { signal });
      hub.addEventListener('submit', event => this.submit(event), { signal });
      hub.addEventListener('input', event => {
        const field = event.target;
        if (field.closest('[data-hub-profile-form], [data-hub-address-form]')) this.clearFieldError(field);
      }, { signal });
      hub.addEventListener('invalid', event => {
        const field = event.target;
        if (field.closest('[data-hub-profile-form], [data-hub-address-form]')) this.fieldError(field, field.validationMessage);
      }, { signal, capture: true });
      hub.addEventListener('change', event => {
        const field = event.target;
        if (field.closest('[data-hub-profile-form], [data-hub-address-form]')) this.clearFieldError(field);
        if (field.matches('[data-hub-profile-phone]') && !field.readOnly) field.value = this.normalizeAccountPhone(field.value) || '+1 ';
      }, { signal });
      hub.querySelector('[data-hub-address-form] [name="countryCode"]')?.addEventListener('change', () => this.setRegions(), { signal });
      this.ready = this.timed('account-startup', () => this.initialize()).catch(() => { this.clearSession(); this.status('connection_failed'); this.controls(); });
      this.ready.then(() => this.activate(this.hub.currentView)).catch(() => { this.status('connection_failed'); this.controls(); });
    }
    clearSession() {
      this.auth = null; this.profile = null; this.preferences = null; this.sessionStarted = null;
      this.hub.loyaltyCatalog?.disconnectMember();
      this.hub.orders?.reset();
      this.hub.offers?.clearWallet();
      try { sessionStorage.removeItem(SESSION_KEY); } catch {}
    }
    persistSession() {
      if (!this.auth || !this.customerId) return;
      try { sessionStorage.setItem(SESSION_KEY, JSON.stringify({ customerId: this.customerId, started: this.sessionStarted || Date.now(), auth: this.auth, config: this.config })); } catch {}
    }
    trustedConfig(config) {
      if (!config || config.issuer !== ISSUER) return null;
      const expected = { authorization_endpoint: ISSUER + '/oauth/authorize', token_endpoint: ISSUER + '/oauth/token', end_session_endpoint: ISSUER + '/logout', graphql: `https://shopify.com/${SHOP_ID}/account/customer/api/2026-10/graphql` };
      if (Object.entries(expected).some(([key, value]) => config[key] !== value)) return null;
      return { issuer: ISSUER, ...expected };
    }
    restoreSession() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(SESSION_KEY) || 'null');
        if (!saved) return;
        const age = Date.now() - saved.started;
        if (!this.customerId || saved.customerId !== this.customerId || !Number.isFinite(saved.started) || age < 0 || age >= SESSION_LIMIT || typeof saved.auth?.access !== 'string' || typeof saved.auth?.id !== 'string' || !Number.isFinite(saved.auth?.expires)) { this.clearSession(); return; }
        this.auth = saved.auth; this.sessionStarted = saved.started;
        this.config = this.trustedConfig(saved.config);
      } catch { this.clearSession(); }
    }
    async activate(destination) {
      if (this.busy && ['profile', 'account-details', 'addresses', 'orders'].includes(destination)) this.status(this.phase || 'loading', [], destination);
      await this.ready;
      if (this.dead || this.loggingOut) return;
      if (this.hub.currentView && this.hub.currentView !== destination) return;
      if (this.statusView && this.statusView !== destination) this.status('');
      this.statusView = destination;
      if (destination === 'account-details' && this.connected()) await this.loadPreferences();
      const privateOffers = destination === 'offers' && this.hub.querySelector('[data-hub-view="offers"]')?.dataset.walletEnabled === 'true';
      if ((!['profile', 'account-details', 'addresses', 'orders'].includes(destination) && !privateOffers) || !this.customerId || this.busy || this.connected()) return;
      if (this.auth) { await this.refresh(); return; }
      let attempted = true;
      try { attempted = sessionStorage.getItem(ATTEMPT_KEY) === this.customerId; } catch {}
      if (!attempted) await this.connect(destination);
      else { this.status('reconnect_required'); this.controls(); }
    }
    t(key) { return this.copy[key] || key; }
    status(key, messages = [], view = this.hub.currentView) {
      if (key === 'connected' && ['orders', 'offers'].includes(view)) key = '';
      const text = key ? [this.t(key), ...messages].join(' ') : '';
      this.phase = ['loading', 'connecting', 'saving'].includes(key) ? key : null;
      this.hub.querySelectorAll('[data-hub-account-status]').forEach(node => {
        const active = node.closest('[data-hub-view]')?.dataset.hubView === view;
        node.textContent = active ? text : '';
        node.setAttribute?.('data-loading', String(active && !!this.phase));
      });
      this.statusView = view;
    }
    connected() { return !!this.auth && !!this.profile && !this.dead; }
    controls() {
      this.preferenceControls();
      this.hub.querySelectorAll('[data-hub-account-controls]').forEach(node => { node.disabled = !this.connected() || this.busy || this.uncertain; });
      const emailPreference = this.hub.querySelector('[data-hub-email-marketing]');
      if (emailPreference) emailPreference.disabled = !this.connected() || this.busy || this.uncertain || this.prefLoading || !this.preferences?.emailEnabled;
      this.hub.querySelectorAll('[data-hub-account-action]').forEach(node => { node.disabled = !this.connected() || this.busy || this.uncertain; });
      this.hub.querySelectorAll('[data-hub-account-connect]').forEach(node => { node.hidden = this.connected(); node.disabled = this.busy; });
      this.hub.querySelectorAll('[data-hub-account-refresh]').forEach(node => {
        const orders = node.closest('[data-hub-view]')?.dataset.hubView === 'orders';
        node.hidden = !this.auth || (orders && this.connected() && !this.uncertain); node.disabled = this.busy;
      });
      this.hub.querySelectorAll('[data-hub-account-instructions]').forEach(node => { node.hidden = this.connected() || this.busy; });
      this.hub.querySelectorAll('[data-hub-account-busy]').forEach(node => node.setAttribute('aria-busy', String(this.busy)));
      this.hub.querySelectorAll('[data-hub-view]').forEach(node => {
        if (['profile', 'account-details', 'addresses', 'address-edit'].includes(node.dataset.hubView)) node.setAttribute('aria-busy', String(this.busy));
      });
    }
    async initialize() {
      this.restoreSession();
      if (!this.customerId) { this.clearSession(); sessionStorage.removeItem(ATTEMPT_KEY); }
      if (sessionStorage.getItem(LOGOUT_KEY)) {
        sessionStorage.removeItem(LOGOUT_KEY);
        sessionStorage.removeItem(PENDING_KEY);
        this.clearSession(); sessionStorage.removeItem(ATTEMPT_KEY); sessionStorage.removeItem(SIGNIN_KEY);
        location.replace(this.hub.dataset.accountLogoutUrl);
        return;
      }
      const url = new URL(location.href);
      let pending;
      try { pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null'); } catch { sessionStorage.removeItem(PENDING_KEY); }
      if (!pending || !(url.searchParams.has('code') || url.searchParams.has('error'))) {
        this.controls();
        // Resume a stored session once, before the customer opens another account view.
        if (this.auth) await this.refresh();
        if (this.customerId && sessionStorage.getItem(SIGNIN_KEY)) {
          sessionStorage.removeItem(SIGNIN_KEY);
          this.hub.open();
          this.hub.navigate('profile');
        }
        return;
      }
      sessionStorage.removeItem(PENDING_KEY);
      const code = url.searchParams.get('code');
      const state = url.searchParams.get('state');
      const error = url.searchParams.get('error');
      for (const key of ['code', 'state', 'error', 'error_description']) url.searchParams.delete(key);
      history.replaceState(null, '', url.pathname + url.search + '#simpson-hub');
      this.hub.open();
      this.hub.navigate(['profile', 'account-details', 'addresses', 'orders', 'loyalty', 'offers'].includes(pending.destination) ? pending.destination : 'profile');
      this.busy = true;
      this.controls();
      this.status('connecting');
      try {
        if (state !== pending.state || Date.now() - pending.created > 600000 || Date.now() < pending.created || pending.redirect !== location.origin + '/' || !this.customerId || this.customerId !== pending.customerId) throw new AccountError('auth_invalid');
        if (error || !code) throw new AccountError('auth_cancelled');
        this.config = this.trustedConfig(pending.config);
        await this.discover();
        const result = await this.token({ grant_type: 'authorization_code', code, code_verifier: pending.verifier, redirect_uri: pending.redirect });
        this.acceptToken(result, pending.nonce);
        await this.load();
        sessionStorage.removeItem(ATTEMPT_KEY);
        this.status('connected');
      } catch (e) { this.clearSession(); this.status(e.key || 'connection_failed'); }
      finally { this.busy = false; this.controls(); }
    }
    async timed(stage, operation) {
      if (!this.diagnostics) return operation();
      const start = performance.now();
      let ok = false;
      try { const value = await operation(); ok = true; return value; }
      finally {
        // Diagnostic failures must never affect authentication or customer actions.
        try {
          this.timings ||= [];
          this.timings.push({ stage, ms: Math.round(performance.now() - start), ok });
          this.timings = this.timings.slice(-30);
          this.hub.setAttribute('data-hub-timings', JSON.stringify(this.timings));
        } catch {}
      }
    }
    async request(url, options = {}, stage = 'account-request') {
      return this.timed(stage, async () => {
        const response = await fetch(url, { ...options, credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer', signal: AbortSignal.timeout(20000) });
        if (!response.ok) { if (response.status === 401) this.clearSession(); throw new AccountError(response.status === 401 ? 'session_expired' : 'connection_failed'); }
        return response.json();
      });
    }
    async discover() {
      if (this.config) return;
      const [oidc, api] = await Promise.all([
        this.request('https://shopsimpsons.com/.well-known/openid-configuration', {}, 'discovery-auth'),
        this.request('https://shopsimpsons.com/.well-known/customer-account-api', {}, 'discovery-api')
      ]);
      const valid = (value, prefix) => typeof value === 'string' && value.startsWith(prefix) && new URL(value).origin === 'https://shopify.com';
      if (oidc.issuer !== ISSUER || !valid(oidc.authorization_endpoint, ISSUER + '/') || !valid(oidc.token_endpoint, ISSUER + '/') || !valid(oidc.end_session_endpoint, ISSUER + '/') || !valid(api.graphql_api, `https://shopify.com/${SHOP_ID}/account/customer/api/`)) throw new AccountError('connection_failed');
      const endpoint = new URL(api.graphql_api);
      endpoint.pathname = endpoint.pathname.replace(/\/api\/[^/]+\/graphql$/, '/api/2026-10/graphql');
      this.config = { ...oidc, graphql: endpoint.href };
      if (this.auth) this.persistSession();
    }
    async connect(destination = this.hub.currentView || 'profile') {
      if (this.busy || !this.customerId) return;
      this.busy = true; this.controls(); this.status('connecting');
      try {
        sessionStorage.setItem(ATTEMPT_KEY, this.customerId);
        if (!isSecureContext || !crypto.subtle || location.origin === 'null') throw new AccountError('connection_failed');
        await this.discover();
        if (this.dead || this.loggingOut || this.hub.drawer?.open === false || (this.hub.currentView && this.hub.currentView !== destination)) {
          sessionStorage.removeItem(ATTEMPT_KEY);
          this.busy = false; this.status(''); this.controls(); return;
        }
        const pending = { verifier: random(), state: random(), nonce: random(), redirect: location.origin + '/', created: Date.now(), customerId: this.customerId, destination, config: this.trustedConfig(this.config) };
        const challenge = base64url(new Uint8Array(await crypto.subtle.digest('SHA-256', enc.encode(pending.verifier))));
        sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending));
        const url = new URL(this.config.authorization_endpoint);
        const parameters = { client_id: CLIENT_ID, scope: 'openid email customer-account-api:full', response_type: 'code', redirect_uri: pending.redirect, state: pending.state, nonce: pending.nonce, code_challenge: challenge, code_challenge_method: 'S256' };
        for (const [key, value] of Object.entries(parameters)) url.searchParams.set(key, value);
        location.assign(url.href);
      } catch (e) { this.status(e.key || 'connection_failed'); this.busy = false; this.controls(); }
    }
    async token(parameters) {
      return this.request(this.config.token_endpoint, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: new URLSearchParams({ client_id: CLIENT_ID, ...parameters }) }, parameters.grant_type === 'refresh_token' ? 'token-refresh' : 'token-exchange');
    }
    acceptToken(result, nonce) {
      if (this.dead || this.loggingOut) throw new AccountError('session_expired');
      if (!result.access_token || !result.id_token || !(Number(result.expires_in) > 0)) throw new AccountError('auth_invalid');
      if (nonce) {
        let claims;
        try {
          const payload = result.id_token.split('.')[1].replaceAll('-', '+').replaceAll('_', '/');
          claims = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(payload), x => x.charCodeAt(0))));
        } catch { throw new AccountError('auth_invalid'); }
        const aud = Array.isArray(claims.aud) ? claims.aud : [claims.aud];
        if (claims.nonce !== nonce || claims.iss !== ISSUER || !aud.includes(CLIENT_ID) || !(claims.exp * 1000 > Date.now())) throw new AccountError('auth_invalid');
      }
      this.auth = { access: result.access_token, refresh: result.refresh_token || this.auth?.refresh, id: result.id_token, expires: Date.now() + result.expires_in * 1000 };
      this.sessionStarted ||= Date.now();
      this.persistSession();
    }
    async access() {
      if (this.sessionStarted && Date.now() - this.sessionStarted >= SESSION_LIMIT) { this.clearSession(); throw new AccountError('session_expired'); }
      if (!this.auth) throw new AccountError('session_expired');
      if (this.auth.expires < Date.now() + 30000) {
        if (!this.auth.refresh) { this.clearSession(); throw new AccountError('session_expired'); }
        this.refreshing ||= this.token({ grant_type: 'refresh_token', refresh_token: this.auth.refresh }).then(result => this.acceptToken(result)).catch(() => { this.clearSession(); throw new AccountError('session_expired'); }).finally(() => { this.refreshing = null; });
        await this.refreshing;
      }
      return this.auth.access;
    }
    async graphql(kind, variables = {}) {
      const access = await this.access();
      const result = await this.request(this.config.graphql, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: access }, body: JSON.stringify({ query: OPERATIONS[kind], variables }) }, `api-${kind}`);
      if (result.errors?.length || !result.data) throw new AccountError('request_failed');
      return result.data;
    }
    async load() {
      let after = null, profile, initialOrders, addresses = [], cursors = new Set();
      do {
        const bootstrap = !this.profile && after === null;
        const data = (await this.graphql(bootstrap ? 'bootstrap' : 'profile', { after })).customer;
        if (!data || data.id !== `gid://shopify/Customer/${this.customerId}`) { this.clearSession(); throw new AccountError('account_mismatch'); }
        profile ||= data;
        if (bootstrap) initialOrders = data;
        addresses.push(...data.addresses.nodes);
        after = data.addresses.pageInfo.hasNextPage ? data.addresses.pageInfo.endCursor : null;
        if (after && cursors.has(after)) throw new AccountError('request_failed');
        if (after) cursors.add(after);
      } while (after);
      if (this.dead) return;
      this.profile = { ...profile, addresses };
      this.uncertain = false;
      this.render();
      this.hub.offers?.activate('home');
      this.hub.loyaltyCatalog?.connectMember();
      if (initialOrders?.orders && this.hub.orders) await this.timed('orders-prepare', () => this.hub.orders.seed(initialOrders));
      sessionStorage.removeItem(ATTEMPT_KEY);
    }
    async refresh() {
      if (this.busy) return;
      const view = this.hub.currentView;
      const checkingSave = this.uncertain;
      this.busy = true; this.controls(); this.status('loading');
      try {
        await this.discover(); await this.load();
        if (view === 'account-details') await this.loadPreferences(true);
        if (checkingSave && view === 'address-edit' && this.hub.currentView === view) this.hub.navigate('addresses');
        this.status('');
        if (view === 'orders' && this.hub.currentView === view && this.connected()) await this.hub.orders?.activate('orders');
      }
      catch (e) { this.status(e.key || 'request_failed', [], view); }
      finally { this.busy = false; this.controls(); }
    }
    element(tag, text, className) {
      const node = document.createElement(tag);
      if (text !== undefined) node.textContent = text;
      if (className) node.className = className;
      return node;
    }
    action(text, action, id, className = 'customer-hub__button customer-hub__button--secondary') {
      const node = this.element('button', this.t(text), className);
      node.type = 'button'; node.dataset.hubAccountAction = action; if (id) node.dataset.addressId = id;
      return node;
    }
    clearFieldError(field) {
      const error = field.parentElement?.querySelector('[data-hub-field-error]');
      if (error) {
        const described = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== error.id);
        if (described.length) field.setAttribute('aria-describedby', described.join(' '));
        else field.removeAttribute('aria-describedby');
        error.remove();
      }
      field.removeAttribute('aria-invalid');
      field.setCustomValidity('');
    }
    clearFormErrors(form) {
      if (!form) return;
      for (const field of form.querySelectorAll('input, select')) this.clearFieldError(field);
    }
    fieldError(field, message) {
      this.clearFieldError(field);
      const error = this.element('small', message, 'customer-hub__field-error');
      error.dataset.hubFieldError = '';
      error.id = `HubFieldError-${this.hub.id || 'account'}-${field.closest('[data-hub-view]')?.dataset.hubView || 'form'}-${field.name}`;
      field.parentElement.append(error);
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
    }
    showFieldErrors(form, errors) {
      let first;
      if (!form) return;
      for (const error of errors) {
        const name = error.field?.at(-1);
        const mapped = name === 'territoryCode' ? 'countryCode' : name === 'zoneCode' ? (form.elements.regionSelect?.disabled ? 'regionInput' : 'regionSelect') : name;
        const field = mapped && form.elements.namedItem(mapped);
        if (!field || field.disabled || !['INPUT', 'SELECT'].includes(field.tagName)) continue;
        this.fieldError(field, error.message);
        first ||= field;
      }
      return first;
    }
    render() {
      const customer = this.profile;
      const name = [customer.firstName, customer.lastName].filter(Boolean).join(' ') || customer.emailAddress?.emailAddress || '';
      this.hub.querySelectorAll('[data-hub-profile-name]').forEach(node => { node.textContent = name; });
      this.hub.querySelectorAll('[data-hub-profile-email]').forEach(node => { if (node.tagName === 'INPUT') node.value = customer.emailAddress?.emailAddress || ''; else node.textContent = customer.emailAddress?.emailAddress || '';  });
      const welcome = this.hub.querySelector('.customer-hub__identity-title');
      if (welcome) welcome.textContent = this.t('welcome').replace('{{ name }}', customer.firstName || name);
      const avatar = this.hub.querySelector('.customer-hub__avatar');
      if (avatar) avatar.textContent = ((customer.firstName || '').slice(0, 1) + (customer.lastName || '').slice(0, 1)).toUpperCase();
      const nameForm = this.hub.querySelector('[data-hub-profile-form]');
      if (nameForm) for (const key of ['firstName', 'lastName']) nameForm.elements[key].value = customer[key] || '';
      this.hub.querySelectorAll('[data-hub-profile-phone]').forEach(node => { node.value = customer.phoneNumber?.phoneNumber || ''; });
      const emailPreference = this.hub.querySelector('[data-hub-email-marketing]');
      const state = customer.emailAddress?.marketingState;
      if (emailPreference) emailPreference.checked = ['SUBSCRIBED', 'PENDING'].includes(state);
      const smsPreference = this.hub.querySelector('[data-hub-sms-marketing]');
      if (smsPreference) smsPreference.checked = ['SUBSCRIBED', 'PENDING'].includes(customer.phoneNumber?.smsMarketingConsent?.state);
      this.renderPreferences();
      const note = this.hub.querySelector('[data-hub-email-marketing-note]');
      if (note) note.textContent = this.t(this.preferences ? 'email_note' : 'preferences_loading');
      this.hub.querySelector('[data-hub-profile-readonly]')?.setAttribute('hidden', '');
      const list = this.hub.querySelector('[data-hub-address-list]');
      if (!list) return;
      list.replaceChildren();
      if (!customer.addresses.length) list.append(this.element('p', this.t('no_addresses')));
      for (const address of customer.addresses) {
        const card = this.element('article', undefined, 'customer-hub__profile-card');
        if (address.id === customer.defaultAddress?.id) card.append(this.element('span', this.t('default_address'), 'customer-hub__default-label'));
        const display = this.element('address');
        for (const line of address.formatted) display.append(this.element('div', line));
        card.append(display);
        const actions = this.element('div', undefined, 'customer-hub__form-actions');
        actions.append(this.action('edit_address', 'edit', address.id), this.action('delete_address', 'delete-prompt', address.id, 'customer-hub__text-link customer-hub__delete-link'));
        card.append(actions);
        const confirmation = this.element('div', undefined, 'customer-hub__delete-confirm');
        confirmation.hidden = true; confirmation.dataset.hubDeleteConfirm = address.id;
        confirmation.append(this.element('p', this.t(address.id === customer.defaultAddress?.id ? 'delete_default_prompt' : 'delete_prompt')));
        const confirmActions = this.element('div', undefined, 'customer-hub__form-actions');
        confirmActions.append(this.action('confirm_delete', 'delete-confirm', address.id), this.action('cancel', 'delete-cancel', address.id));
        confirmation.append(confirmActions); card.append(confirmation); list.append(card);
      }
    }
    setRegions(value = '') {
      const form = this.hub.querySelector('[data-hub-address-form]');
      const select = form.querySelector('[data-hub-region-select]');
      const input = form.querySelector('[data-hub-region-input]');
      const regions = REGIONS[form.elements.countryCode.value];
      select.replaceChildren(new Option(this.t('select_region'), ''));
      if (regions) for (const region of regions.split('|')) { const [code, name] = region.split(':'); select.add(new Option(name, code)); }
      select.hidden = !regions; select.disabled = !regions; select.required = !!regions;
      input.hidden = !!regions; input.disabled = !!regions;
      select.value = value; input.value = value;
    }
    editAddress(id) {
      if (!this.connected() || this.busy || this.uncertain) return;
      const address = id ? this.profile.addresses.find(x => x.id === id) : null;
      if (id && !address) return;
      this.editId = id || null;
      const form = this.hub.querySelector('[data-hub-address-form]');
      form.reset();
      this.clearFormErrors(form);
      const country = form.elements.countryCode;
      if (!country.options.length) {
        const labels = new Intl.DisplayNames([this.hub.dataset.locale || 'en'], { type: 'region' });
        const countries = COUNTRIES.map(code => [code, labels.of(code)]).sort((a, b) => a[1].localeCompare(b[1]));
        for (const [code, label] of countries) country.add(new Option(label, code));
      }
      for (const key of ['firstName', 'lastName', 'company', 'address1', 'address2', 'city', 'zip', 'phoneNumber']) form.elements[key].value = address?.[key] || (['firstName', 'lastName'].includes(key) ? this.profile[key] || '' : '');
      country.value = address?.countryCode || this.hub.dataset.countryCode || 'US';
      this.setRegions(address?.zoneCode || '');
      const isDefault = address && address.id === this.profile.defaultAddress?.id;
      form.elements.defaultAddress.checked = !!isDefault;
      form.elements.defaultAddress.disabled = !!isDefault;
      this.hub.querySelector('[data-hub-address-title]').textContent = this.t(id ? 'edit_address' : 'add_address');
      this.status(''); this.hub.navigate('address-edit');
    }
    async click(event) {
      if (event.target.closest('[data-hub-sign-in]')) { try { sessionStorage.setItem(SIGNIN_KEY, '1'); } catch {} return; }
      const button = event.target.closest('[data-hub-native-profile], [data-hub-account-connect], [data-hub-account-refresh], [data-hub-account-action], [data-hub-account-sign-out]');
      if (!button || !this.hub.contains(button)) return;
      event.preventDefault();
      if (button.matches('[data-hub-native-profile]')) {
        const destination = new URL(button.dataset.hubNativeProfile, location.origin);
        if (destination.protocol === 'https:' && destination.hostname === 'shopify.com' && destination.pathname === `/${SHOP_ID}/account/profile`) window.open(destination.href, '_blank', 'noopener,noreferrer');
        return;
      }
      if (button.matches('[data-hub-account-sign-out]')) { await this.logout(this.hub.dataset.accountLogoutUrl || button.href); return; }
      if (button.matches('[data-hub-account-connect]')) { await this.connect(); return; }
      if (button.matches('[data-hub-account-refresh]')) { await this.refresh(); return; }
      if (!this.connected() || this.busy || this.uncertain) return;
      const id = button.dataset.addressId;
      switch (button.dataset.hubAccountAction) {
        case 'add': this.editAddress(); break;
        case 'edit': this.editAddress(id); break;
        case 'delete-prompt':
          this.hub.querySelectorAll('[data-hub-delete-confirm]').forEach(node => { node.hidden = node.dataset.hubDeleteConfirm !== id; });
          button.closest('article').querySelector('[data-hub-account-action="delete-confirm"]').focus(); break;
        case 'delete-cancel': button.closest('[data-hub-delete-confirm]').hidden = true; button.closest('article').querySelector('[data-hub-account-action="delete-prompt"]').focus(); break;
        case 'delete-confirm': await this.mutate('delete', { addressId: id }, 'customerAddressDelete', 'address_deleted'); break;
      }
    }
    async submit(event) {
      const form = event.target;
      if (!form.matches('[data-hub-profile-form], [data-hub-address-form]')) return;
      event.preventDefault();
      if (!this.connected() || this.busy || this.uncertain) return;
      this.clearFormErrors(form);
      for (const field of form.querySelectorAll('input[required]')) {
        if (!field.value.trim()) field.setCustomValidity(this.t('required_field'));
      }
      if (!form.reportValidity()) return;
      if (form.matches('[data-hub-profile-form]')) {
        await this.saveProfile(form);
      } else {
        const address = {};
        for (const key of ['firstName', 'lastName', 'company', 'address1', 'address2', 'city', 'zip', 'phoneNumber', 'countryCode']) address[key] = form.elements[key].value.trim();
        const region = form.querySelector('[data-hub-region-select]:not([disabled]), [data-hub-region-input]:not([disabled])');
        address.zoneCode = region?.value.trim() || '';
        const variables = { address, defaultAddress: form.elements.defaultAddress.checked ? true : this.editId ? null : false };
        if (this.editId) variables.addressId = this.editId;
        await this.mutate(this.editId ? 'update' : 'create', variables, this.editId ? 'customerAddressUpdate' : 'customerAddressCreate', 'address_saved', 'addresses');
      }
    }
    emailPreferenceKnown() {
      return ['SUBSCRIBED', 'NOT_SUBSCRIBED', 'UNSUBSCRIBED', 'PENDING'].includes(this.profile?.emailAddress?.marketingState);
    }
    async preferenceRequest(input) {
      const token = await this.access();
      let response, data;
      try {
        response = await fetch('https://simpson-hub-api.grant-286.workers.dev/preferences', {
          method:'POST',headers:{Authorization:`Bearer ${token}`,'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify(input),credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',signal:AbortSignal.timeout(30000)
        });
        data = await response.json();
      } catch { throw new AccountError(input.action === 'save' ? 'save_uncertain' : 'preferences_unavailable'); }
      if (!response.ok) {
        if (response.status === 401) { this.clearSession(); throw new AccountError('session_expired'); }
        const messages = {
          unsubscribe_before_phone_change:'phone_unsubscribe_first',preferences_phone_in_use:'phone_in_use',
          preferences_profile_ambiguous:'duplicate_profile',
          preferences_phone_required:'phone_required',preferences_invalid_request:'phone_format',
          preferences_changed_refresh_required:'preferences_changed',preferences_validation_failed:'preferences_validation_failed'
        };
        const error = new AccountError(messages[data.error] || (input.action === 'save' ? 'save_uncertain' : 'preferences_unavailable'));
        const diagnostic = data.diagnostic || data.error;
        if (/^[a-z_]{1,80}$/.test(diagnostic || '')) error.diagnostic = diagnostic;
        throw error;
      }
      if (data.customerId !== `gid://shopify/Customer/${this.customerId}`) { this.clearSession(); throw new AccountError('account_mismatch'); }
      return data;
    }
    async loadPreferences(force = false) {
      if (!this.connected() || this.prefLoading || (!force && this.preferences)) return;
      this.prefLoading = true; this.prefError = false; this.prefErrorCode = ''; this.prefErrorMessage = ''; this.preferenceControls();
      try {
        const result = await this.preferenceRequest({action:'read'});
        if (this.dead || !this.connected()) return;
        this.preferences = result; this.renderPreferences();
      } catch (error) { this.preferences = null; this.prefError = true; this.prefErrorMessage = error.key === 'duplicate_profile' ? 'duplicate_profile' : 'preferences_unavailable'; this.prefErrorCode = error.diagnostic || error.key || 'preferences_unavailable'; }
      finally { this.prefLoading = false; this.preferenceControls(); }
    }
    preferenceControls() {
      const p = this.preferences, locked = !this.connected() || this.busy || this.prefLoading || this.uncertain;
      const email = this.hub.querySelector('[data-hub-email-marketing]');
      const sms = this.hub.querySelector('[data-hub-sms-marketing]');
      const transactional = this.hub.querySelector('[data-hub-sms-transactional]');
      const phone = this.hub.querySelector('[data-hub-profile-phone]');
      if (email) email.disabled = locked || !p?.emailEnabled;
      if (sms) sms.disabled = locked || !p?.smsEnabled;
      if (transactional) transactional.disabled = locked || !p?.smsTransactionalEnabled;
      const transactionalStatus = this.hub.querySelector('[data-hub-sms-transactional-status]');
      if (transactionalStatus) transactionalStatus.textContent = this.t(this.prefLoading ? 'preferences_loading' :
        p?.smsTransactional?.state === 'INCLUDED_IN_MARKETING' ? 'transactional_included_in_marketing' :
        p?.smsTransactional?.state === 'SUBSCRIBED' ? 'transactional_subscribed' :
        p?.smsTransactional?.state === 'NEVER_SUBSCRIBED' ? 'transactional_never_subscribed' :
        p?.smsTransactional?.state === 'UNSUBSCRIBED' ? 'transactional_unsubscribed' : 'transactional_unknown');
      if (phone) phone.readOnly = locked || !p?.phoneEnabled;
      const note = this.hub.querySelector('[data-hub-preferences-status]');
      if (note) note.textContent = this.t(this.prefLoading ? 'preferences_loading' : this.prefError ? (this.prefErrorMessage || 'preferences_unavailable') :
        !p || !p.emailEnabled || !p.smsEnabled ? 'preferences_setup_pending' : 'preferences_connected');
      if (note) {
        note.setAttribute('data-hub-preference-error', this.prefErrorCode || '');
        if (this.diagnostics && this.prefError && this.prefErrorCode) note.textContent += ` (Diagnostic: ${this.prefErrorCode})`;
      }
      const emailNote = this.hub.querySelector('[data-hub-email-marketing-note]');
      if (emailNote && !p) emailNote.textContent = this.t(this.prefError ? 'preferences_unavailable' : 'preferences_loading');
    }
    renderPreferences() {
      const p = this.preferences;
      if (!p) return;
      const note = this.hub.querySelector('[data-hub-email-marketing-note]');
      if (note) note.textContent = this.t(p.email.state === 'UNKNOWN' ? 'email_unknown' : 'email_note');
      const phone = this.hub.querySelector('[data-hub-profile-phone]');
      if (phone) phone.value = p.phone || '+1 ';
      for (const channel of ['email','sms']) {
        const field = this.hub.querySelector(`[data-hub-${channel}-marketing]`);
        if (field) field.checked = p[channel].state === 'SUBSCRIBED';
      }
      const transactional = this.hub.querySelector('[data-hub-sms-transactional]');
      if (transactional) transactional.checked = p.smsTransactional?.state === 'SUBSCRIBED';
      this.preferenceControls();
    }

    normalizeAccountPhone(value) {
      const phone = value.trim().replace(/[\s().-]/g,'');
      if (!phone || phone === '+1') return '';
      if (/^\d{10}$/.test(phone)) return '+1' + phone;
      if (/^1\d{10}$/.test(phone)) return '+' + phone;
      return phone;
    }
    async saveProfile(form) {
      if (this.busy || this.prefLoading || !this.connected() || this.uncertain) return;
      const view = this.hub.currentView;
      const input = {firstName:form.elements.firstName.value.trim(),lastName:form.elements.lastName.value.trim()};
      const namesChanged = Object.keys(input).some(key=>input[key] !== (this.profile[key] || ''));
      const p = this.preferences, changes = {};
      if (p) {
        const phone = this.normalizeAccountPhone(form.elements.accountPhone.value);
        if (!form.elements.accountPhone.readOnly && phone !== p.phone) changes.phone = phone;
        for (const channel of ['email','sms']) if (!form.elements[channel+'Marketing'].disabled &&
          form.elements[channel+'Marketing'].checked !== (p[channel].state === 'SUBSCRIBED')) changes[channel] = form.elements[channel+'Marketing'].checked;
        const transactional = form.elements.smsTransactional;
        if (transactional && !transactional.disabled && transactional.checked !== (p.smsTransactional?.state === 'SUBSCRIBED')) changes.smsTransactional = transactional.checked;
      }
      if ('phone' in changes && !/^\+[1-9]\d{7,14}$/.test(changes.phone)) { this.status('phone_format'); return; }
      if (!namesChanged && !Object.keys(changes).length) {
        await this.loadPreferences(true);
        this.status(this.prefError ? 'preferences_unavailable' : 'profile_unchanged');
        return;
      }
      this.busy = true; this.controls(); this.status('saving');
      let confirmed = false;
      try {
        // Validate/save preferences first; do not retry writes after an uncertain result.
        let preferencesResult;
        if (Object.keys(changes).length) preferencesResult = await this.preferenceRequest({action:'save',version:p.version,...changes});
        if (preferencesResult) confirmed = true;
        if (namesChanged) {
          const result = (await this.graphql('name',{input})).customerUpdate;
          if (!result?.customer || result.userErrors?.length) throw new AccountError('validation_failed');
          confirmed = true;
        }
        await this.load();
        await this.loadPreferences(true);
        if (this.prefError) {
          this.uncertain = true;
          this.status('saved_refresh_failed',[],view);
        } else if (preferencesResult?.accepted) {
          this.uncertain = true;
          this.status('preferences_submitted',[],view);
        } else { this.status('profile_saved',[],view); }
      } catch (error) {
        const validation = ['phone_unsubscribe_first','phone_in_use','phone_required','phone_format','preferences_changed','preferences_validation_failed','validation_failed','duplicate_profile'].includes(error.key);
        this.uncertain = !validation || confirmed;
        this.status(confirmed ? 'partial_profile_saved' : error.key || 'save_uncertain',
          this.diagnostics && /^[a-z_]{1,80}$/.test(error.diagnostic || '') ? ['(Diagnostic: ' + error.diagnostic + ')'] : [],view);
      } finally { this.busy = false; this.controls(); }
    }
    async mutate(kind, variables, key, success, destination) {
      if (this.busy || !this.connected() || this.uncertain) return;
      const view = this.hub.currentView;
      this.busy = true; this.controls(); this.status('saving');
      let confirmed = false, invalidField;
      const form = kind === 'delete' ? null : this.hub.querySelector?.(kind === 'name' ? '[data-hub-profile-form]' : '[data-hub-address-form]');
      try {
        const result = (await this.graphql(kind, variables))[key];
        if (!result) throw new AccountError('request_failed');
        if (result.userErrors?.length) {
          const error = new AccountError('validation_failed', result.userErrors.map(x => x.message));
          error.fields = result.userErrors;
          throw error;
        }
        if (!(result.customer || result.customerAddress || result.deletedAddressId)) throw new AccountError('request_failed');
        confirmed = true;
        await this.load();
        if (destination && this.hub.currentView === view) this.hub.navigate(destination);
        this.status(success, [], destination || view);
      } catch (e) {
        if (e.key === 'validation_failed') {
          this.status(e.key, e.messages, view);
          invalidField = this.showFieldErrors(form, e.fields || []);
        }
        else {
          this.uncertain = true;
          this.status(e.key === 'session_expired' ? e.key : confirmed ? 'saved_refresh_failed' : 'save_uncertain', [], view);
        }
      } finally {
        this.busy = false; this.controls();
        if (this.hub.currentView === view) invalidField?.focus();
      }
    }
    async logout(fallback) {
      if (this.loggingOut) return;
      this.loggingOut = true;
      sessionStorage.removeItem(PENDING_KEY);
      sessionStorage.removeItem(ATTEMPT_KEY); sessionStorage.removeItem(SIGNIN_KEY);
      const id = this.auth?.id;
      this.clearSession(); this.controls();
      if (!id) { location.assign(fallback); return; }
      try { await this.discover(); } catch { location.assign(fallback); return; }
      sessionStorage.setItem(LOGOUT_KEY, '1');
      const url = new URL(this.config.end_session_endpoint);
      url.searchParams.set('id_token_hint', id);
      url.searchParams.set('post_logout_redirect_uri', location.origin + '/');
      location.assign(url.href);
    }
    destroy() { this.dead = true; this.auth = null; this.profile = null; }
  }
  window.SimpsonHubAccount = SimpsonHubAccount;
})();
